import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "contentWrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "splide__list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultItem = _resolveComponent("ResultItem")!

  return (_ctx.resultType === 'ResultArticles')
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultsToRender, (resultItem, index) => {
          return (_openBlock(), _createBlock(_component_ResultItem, {
            key: resultItem.id,
            result: resultItem,
            resultType: _ctx.resultType,
            language: _ctx.language,
            itemIndex: index,
            defaultSiteImageUrl: _ctx.defaultSiteImageUrl
          }, null, 8, ["result", "resultType", "language", "itemIndex", "defaultSiteImageUrl"]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultsToRender, (resultItem, index) => {
          return (_openBlock(), _createBlock(_component_ResultItem, {
            key: resultItem.id,
            result: resultItem,
            resultType: _ctx.resultType,
            language: _ctx.language,
            itemIndex: index,
            defaultSiteImageUrl: _ctx.defaultSiteImageUrl
          }, null, 8, ["result", "resultType", "language", "itemIndex", "defaultSiteImageUrl"]))
        }), 128))
      ]))
}